"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialsFromName = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var lodash_1 = require("lodash");
var react_2 = require("react");
var Tooltip_1 = __importDefault(require("../../Tooltip"));
var AvatarPlaceholder_1 = require("./AvatarPlaceholder");
var styles_1 = require("./styles");
var assets_1 = require("../../../assets");
var _base_1 = require("./_base");
var getInitialsFromName = function (name) {
    if (!name) {
        return '';
    }
    var nameParts = name.split(' ');
    if (nameParts.length === 1) {
        return nameParts[0].charAt(0).toUpperCase();
    }
    return ("" + nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
};
exports.getInitialsFromName = getInitialsFromName;
var BaseAvatarInternal = function (props) {
    var indicator = props.indicator, wrapperSize = props.wrapperSize, indicatorSize = props.indicatorSize, fontSize = props.fontSize, iconSize = props.iconSize, src = props.src, className = props.className, _a = props.placeholderType, placeholderType = _a === void 0 ? 'text' : _a, PlaceholderIcon = props.placeholderIcon, _b = props.avatarTextBaseColor, avatarTextBaseColor = _b === void 0 ? 'Gray' : _b, alt = props.alt, name = props.name, _c = props.tooltip, tooltip = _c === void 0 ? name : _c, wrapperClassName = props.wrapperClassName, _d = props.imageFit, imageFit = _d === void 0 ? 'cover' : _d, _e = props.type, type = _e === void 0 ? 'user' : _e, company = props.company, companyIndicator = props.companyIndicator, rest = __rest(props, ["indicator", "wrapperSize", "indicatorSize", "fontSize", "iconSize", "src", "className", "placeholderType", "placeholderIcon", "avatarTextBaseColor", "alt", "name", "tooltip", "wrapperClassName", "imageFit", "type", "company", "companyIndicator"]);
    var contentToRender;
    var hasImageElement = react_2.isValidElement(src);
    var styles = styles_1.getAvatarStyles(wrapperSize, fontSize, indicatorSize, imageFit, type, !!rest.onClick);
    var avatarTextBaseStyle = styles_1.getAvatarTextBaseStyle(avatarTextBaseColor);
    if (type === 'company' && company) {
        contentToRender = react_1.jsx("img", { src: assets_1.AvatarCompanyLogoAsset[company], alt: alt });
    }
    else if (typeof src === 'string') {
        contentToRender = react_1.jsx("img", { src: src, alt: alt });
    }
    else if (hasImageElement) {
        contentToRender = src;
    }
    else if (placeholderType === 'icon') {
        contentToRender = PlaceholderIcon ? (react_1.jsx(PlaceholderIcon, { size: iconSize })) : (react_1.jsx(AvatarPlaceholder_1.AvatarPlaceholder, { type: type }));
    }
    else if (placeholderType === 'text' && name) {
        contentToRender = react_1.jsx("strong", { css: styles.text }, exports.getInitialsFromName(name));
    }
    var divProps = lodash_1.omit(rest, ['email']);
    var renderedIndicator = indicator;
    if (companyIndicator) {
        renderedIndicator = (react_1.jsx(_base_1.AvatarCompanyIndicator, { size: indicatorSize + 4, company: companyIndicator }));
    }
    return (react_1.jsx(Tooltip_1.default, { overlay: tooltip, placement: "top" },
        react_1.jsx("div", __assign({ css: styles.root }, divProps, { className: wrapperClassName }),
            react_1.jsx("div", { css: [styles.content, avatarTextBaseStyle], className: className }, contentToRender),
            renderedIndicator ? react_1.jsx("div", { css: styles.indicator }, renderedIndicator) : null)));
};
exports.default = BaseAvatarInternal;
